import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-83015b08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-style-panel" }
const _hoisted_2 = { class: "clip" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "shape-clip" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "title"
}
const _hoisted_7 = { class: "dialog-imgType" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { style: {"max-height":"450px","overflow-y":"scroll"} }
const _hoisted_10 = { class: "pptImg-opt-pre" }
const _hoisted_11 = { class: "pptImg-opt-use" }
const _hoisted_12 = { style: {"margin-top":"10px"} }

import { Ref, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { PPTImageElement, SlideBackground } from '@/types/slides'
import { CLIPPATHS,CLIPPATHS2 } from '@/configs/imageClip'
import { getImageDataURL } from '@/utils/image'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'
import { useI18n } from 'vue-i18n'
import ElementOutline from '../common/ElementOutline.vue'
import ElementShadow from '../common/ElementShadow.vue'
import ElementFlip from '../common/ElementFlip.vue'
import ElementFilter from '../common/ElementFilter.vue'
import ElementColorMask from '../common/ElementColorMask.vue'
import FileInput from '@/components/FileInput.vue'
import {
  Divider,
  Button,
  Popover,
  Modal,
  Image,
  Spin,
} from 'ant-design-vue'
import { getPPTImageTypeList, getTypeImgList } from '@/api/combo'


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageStylePanel',
  setup(__props) {

const { t, locale } = useI18n()

const ButtonGroup = Button.Group

const shapeClipPathOptions = CLIPPATHS2
const ratioClipOptions = [
  {
    label: t(`editor.toolbar.elementStylePanel.imageStylePanel.clip1`), // '按纵横比（方形）',
    children: [
      { key: '1:1', ratio: 1 / 1 },
    ],
  },
  {
    label: t(`editor.toolbar.elementStylePanel.imageStylePanel.clip2`), // '按纵横比（纵向）',
    children: [
      { key: '2:3', ratio: 3 / 2 },
      { key: '3:4', ratio: 4 / 3 },
      { key: '3:5', ratio: 5 / 3 },
      { key: '4:5', ratio: 5 / 4 },
    ],
  },
  {
    label: t(`editor.toolbar.elementStylePanel.imageStylePanel.clip3`), // '按纵横比（横向）',
    children: [
      { key: '3:2', ratio: 2 / 3 },
      { key: '4:3', ratio: 3 / 4 },
      { key: '5:3', ratio: 3 / 5 },
      { key: '5:4', ratio: 4 / 5 },
    ],
  },
  {
    children: [
      { key: '16:9', ratio: 9 / 16 },
      { key: '16:10', ratio: 10 / 16 },
    ],
  },
]

const mainStore = useMainStore()
const slidesStore = useSlidesStore()
const { handleElement, handleElementId } = storeToRefs(mainStore)
const { currentSlide } = storeToRefs(slidesStore)

const handleImageElement = handleElement as Ref<PPTImageElement>

const clipPanelVisible = ref(false)

const { addHistorySnapshot } = useHistorySnapshot()

// 打开自由裁剪
const clipImage = () => {
  mainStore.setClipingImageElementId(handleElementId.value)
  clipPanelVisible.value = false
}

// 获取原始图片的位置大小
const getImageElementDataBeforeClip = () => {
  const _handleElement = handleElement.value as PPTImageElement

  // 图片当前的位置大小和裁剪范围
  const imgWidth = _handleElement.width
  const imgHeight = _handleElement.height
  const imgLeft = _handleElement.left
  const imgTop = _handleElement.top
  const originClipRange: [[number, number], [number, number]] = _handleElement.clip ? _handleElement.clip.range : [[0, 0], [100, 100]]

  const originWidth = imgWidth / ((originClipRange[1][0] - originClipRange[0][0]) / 100)
  const originHeight = imgHeight / ((originClipRange[1][1] - originClipRange[0][1]) / 100)
  const originLeft = imgLeft - originWidth * (originClipRange[0][0] / 100)
  const originTop = imgTop - originHeight * (originClipRange[0][1] / 100)

  return {
    originClipRange,
    originWidth,
    originHeight,
    originLeft,
    originTop,
  }
}

// 预设裁剪
const presetImageClip = (shape: string, ratio = 0) => {
  const _handleElement = handleElement.value as PPTImageElement
  const {
    originClipRange,
    originWidth,
    originHeight,
    originLeft,
    originTop,
  } = getImageElementDataBeforeClip()
  
  // 纵横比裁剪（形状固定为矩形）
  if (ratio) {
    const imageRatio = originHeight / originWidth

    const min = 0
    const max = 100
    let range: [[number, number], [number, number]]

    if (imageRatio > ratio) {
      const distance = ((1 - ratio / imageRatio) / 2) * 100
      range = [[min, distance], [max, max - distance]]
    }
    else {
      const distance = ((1 - imageRatio / ratio) / 2) * 100
      range = [[distance, min], [max - distance, max]]
    }
    slidesStore.updateElement({
      id: handleElementId.value,
      props: {
        clip: { ..._handleElement.clip, shape, range },
        left: originLeft + originWidth * (range[0][0] / 100),
        top: originTop + originHeight * (range[0][1] / 100),
        width: originWidth * (range[1][0] - range[0][0]) / 100,
        height: originHeight * (range[1][1] - range[0][1]) / 100,
      },
    })
  }
  // 形状裁剪（保持当前裁剪范围）
  else {
    slidesStore.updateElement({
      id: handleElementId.value,
      props: {
        clip: { ..._handleElement.clip, shape, range: originClipRange }
      },
    })
  }
  clipImage()
  addHistorySnapshot()
}

// 替换图片（保持当前的样式）
const replaceImage = (files: FileList) => {
  const imageFile = files[0]
  if (!imageFile) return
  getImageDataURL(imageFile).then(dataURL => {
    const props = { src: dataURL }
    slidesStore.updateElement({ id: handleElementId.value, props })
  })
  addHistorySnapshot()
}

// 重置图片：清除全部样式
const resetImage = () => {
  const _handleElement = handleElement.value as PPTImageElement

  if (_handleElement.clip) {
    const {
      originWidth,
      originHeight,
      originLeft,
      originTop,
    } = getImageElementDataBeforeClip()

    slidesStore.updateElement({
      id: handleElementId.value,
      props: {
        left: originLeft,
        top: originTop,
        width: originWidth,
        height: originHeight,
      },
    })
  }

  slidesStore.removeElementProps({
    id: handleElementId.value,
    propName: ['clip', 'outline', 'flip', 'shadow', 'filters', 'colorMask'],
  })
  addHistorySnapshot()
}
// 从服务器查询图片分类，然后按分类分页查询图片列表
// 打开图片选择
const dialogForServerImage = ref(false)
const pptImgTypeList = ref()
const pptImgTypeIndex = ref(0)

const searchImage = () => {
  dialogForServerImage.value = true
  getPPTImageTypeList({
    parentId: 0
  }).then((res: any) => {
    if (res.data) {
      pptImgTypeList.value = res.data
      pptImgTypeIndex.value = 0
      changeImgType(0, pptImgTypeList.value[0].id)
    }
  })
}
const pptImgList = ref()
const loadImgs = ref(false)
const changeImgType = (index: number, itemId: number) => {
  loadImgs.value = true
  pptImgTypeIndex.value = index
  getTypeImgList({
    parentId: 0,
    id: itemId
  }).then((res: any) => {
    if (res.data) {
      pptImgList.value = res.data
      console.log('pptImgList.value:', pptImgList.value)
    }
    loadImgs.value = false
  }).catch((err) => {
    loadImgs.value = false
  })

}
const useImg = (index: number) => {
  const selectImgUrl = pptImgList.value[index]
  pptImgTypeIndex.value = index
  // getImageDataURL(selectImgUrl).then(dataURL => {
  const props = { src: selectImgUrl }
  slidesStore.updateElement({ id: handleElementId.value, props })
  // })
  addHistorySnapshot()
  
}
const visible = ref(-1)
const visibleImg = (index: number) => {
  pptImgTypeIndex.value = index
  visible.value = index
}

// 将图片设置为背景
const setBackgroundImage = () => {
  const _handleElement = handleElement.value as PPTImageElement

  const background: SlideBackground = {
    ...currentSlide.value.background,
    type: 'image',
    image: _handleElement.src,
    imageSize: 'cover',
  }
  slidesStore.updateSlide({ background })
  addHistorySnapshot()
}

return (_ctx: any,_cache: any) => {
  const _component_IconTailoring = _resolveComponent("IconTailoring")!
  const _component_IconDown = _resolveComponent("IconDown")!
  const _component_IconTransform = _resolveComponent("IconTransform")!
  const _component_IconUndo = _resolveComponent("IconUndo")!
  const _component_IconTheme = _resolveComponent("IconTheme")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "origin-image",
      style: _normalizeStyle({ backgroundImage: `url(${_unref(handleImageElement).src})` })
    }, null, 4),
    _createVNode(ElementFlip),
    _createVNode(_unref(ButtonGroup), { class: "row tr_row" }, {
      default: _withCtx(() => [
        _createVNode(_unref(Button), {
          style: {"flex":"5"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (clipImage()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconTailoring, { class: "btn-icon" }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.imageStylePanel.cutImg`)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Popover), {
          trigger: "click",
          visible: clipPanelVisible.value,
          "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((clipPanelVisible).value = $event))
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.imageStylePanel.shape`)) + "：", 1),
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(shapeClipPathOptions), (item, key) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "shape-clip-item",
                    key: key,
                    onClick: ($event: any) => (presetImageClip(key))
                  }, [
                    _createElementVNode("div", {
                      class: "shape",
                      style: _normalizeStyle({ clipPath: item.style })
                    }, null, 4)
                  ], 8, _hoisted_5))
                }), 128))
              ]),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ratioClipOptions, (type) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: type.label
                }, [
                  (type.label)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(type.label) + "：", 1))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(ButtonGroup), { class: "row" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type.children, (item) => {
                        return (_openBlock(), _createBlock(_unref(Button), {
                          style: {"flex":"1"},
                          key: item.key,
                          onClick: ($event: any) => (presetImageClip('rect', item.ratio))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.key), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024)
                ], 64))
              }), 64))
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              class: "no-padding",
              style: {"flex":"1"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconDown)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["visible"])
      ]),
      _: 1
    }),
    _createVNode(_unref(Modal), {
      visible: dialogForServerImage.value,
      centered: "",
      width: 856,
      destroyOnClose: ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(Button), {
          style: {"color":"#fff","border":"none"},
          key: "submit",
          type: "primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (dialogForServerImage.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t(`public.close`)), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.imageStylePanel.type`)), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pptImgTypeList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(pptImgTypeIndex.value == index? 'imgType imgTypeActive' : 'imgType'),
              key: index,
              onClick: ($event: any) => (changeImgType(index, item.id))
            }, _toDisplayString(item.name), 11, _hoisted_8))
          }), 128))
        ]),
        _createVNode(_unref(Spin), {
          spinning: loadImgs.value,
          size: "large",
          delay: 500
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pptImgList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "pptImg-body"
                }, [
                  _createVNode(_unref(Image), {
                    class: "pptImg",
                    style: {"padding":"5px","width":"200px","height":"150px"},
                    src: item
                  }, {
                    previewMask: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", null, [
                          _createVNode(_unref(Button), {
                            key: "submit",
                            type: "primary",
                            onClick: ($event: any) => (visibleImg(index))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.imageStylePanel.preview`)), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["src"]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_unref(Button), {
                        key: "submit",
                        type: "primary",
                        onClick: ($event: any) => (useImg(index))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.imageStylePanel.use`)), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["spinning"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(FileInput, {
      onChange: _cache[3] || (_cache[3] = files => replaceImage(files))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Button), { class: "full-width-btn" }, {
          default: _withCtx(() => [
            _createVNode(_component_IconTransform, { class: "btn-icon" }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.imageStylePanel.uploadAndReplace`)), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(Button), {
      class: "full-width-btn",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (resetImage()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_IconUndo, { class: "btn-icon" }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.imageStylePanel.reSetStyle`)), 1)
      ]),
      _: 1
    }),
    _createVNode(_unref(Button), {
      class: "full-width-btn",
      onClick: _cache[5] || (_cache[5] = ($event: any) => (setBackgroundImage()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_IconTheme, { class: "btn-icon" }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.imageStylePanel.setBackground`)), 1)
      ]),
      _: 1
    })
  ]))
}
}

})